import noUiSlider from 'nouislider'

// import './lib/debug'

import './lib/animations'

import {
  faalkansText
} from './lib/data'

import {
  getPipingPolygonPoints,
  getPolygonPoints
} from './lib/dike'

import {
  getScenario,
  resetScenario,
  setScenario
} from './lib/scenario'

import {
  Dijk,
  faalkansLayers,
  variatiesLayers,
  updateIndicator,
  updateScene,
  togglePopup,
  toggleWater
} from './lib/stage'

const form     = document.querySelector('#controls')
const controls = Array.from(document.querySelectorAll('input[type="range"]'))
const noUiSliders = []
const popupControls = Array.from(document.querySelectorAll('.button-icon[id^="pop--up--button"]'))
const waterControl = document.querySelector('#water--toggle')

const resetControls = () =>
  noUiSliders.forEach(slider =>
    slider.noUiSlider.set(slider.noUiSlider.options.start))

window.debug = true;

// Select the scenario

document.querySelectorAll('[data-js-select-scenario]').forEach(node =>
  node.addEventListener('click', event => {
    event.preventDefault()

    resetControls()
    resetScenario()
    updateScene()

    const selectedSenario = node.dataset.jsSelectScenario

    document.querySelector('.header--intro').style.opacity = 0;

    if (selectedSenario === 'faalkans') {
      faalkansLayers.forEach(layer =>
        document.querySelectorAll(layer).forEach(layerNode =>
          layerNode.style.opacity = 1))
      variatiesLayers.forEach(layer =>
        document.querySelectorAll(layer).forEach(layerNode =>
          layerNode.style.opacity = 0))
    }

    if (selectedSenario === 'variaties') {
      faalkansLayers.forEach(layer =>
        document.querySelectorAll(layer).forEach(layerNode =>
          layerNode.style.opacity = 0))
      variatiesLayers.forEach(layer =>
        document.querySelectorAll(layer).forEach(layerNode =>
          layerNode.style.opacity = 1))
    }

    document.querySelector('#menu--bg').style.opacity = 1;
    document.querySelector('#indicator--kruinhoogte').style.opacity = 1;
  }))

document.querySelectorAll('.button--back').forEach(node => {
  node.addEventListener('click', event => {
    event.preventDefault()

    ;[
      ...faalkansLayers,
      ...variatiesLayers
    ].forEach(layer =>
      document.querySelectorAll(layer).forEach(layerNode =>
        layerNode.style.opacity = 0))

    document.querySelector('#menu--bg').style.opacity = 0;
    document.querySelector('.header--intro').style.opacity = 1;
    document.querySelector('#indicator--kruinhoogte').style.opacity = 0;

    resetControls()
    resetScenario()
    updateScene()
    })
  })

// ---

form.addEventListener('reset', event => {

  resetScenario()
  updateScene()
})

controls.forEach(control => {
  const slider = document.createElement('div')

  slider.className = control.className

  noUiSlider.create(slider, {
    behaviour: 'tap-drag', // Move handle on tap, bar is draggable
    range: {
      min: parseInt(control.min),
      max: parseInt(control.max)
    },
    start: Math.floor(control.max / 2),
    step: 1
  })

  noUiSliders.push(slider)

  slider.noUiSlider.on('update', (values, handle) => {
    setScenario(control.name, parseInt(values[handle]))
    updateScene()
  })

  if (parseInt(control.max) === 1) {
    slider.addEventListener('click', event => {
      slider.noUiSlider.set(parseInt(slider.noUiSlider.get()) ? 0 : 1)
    })
  }

  control.parentNode.appendChild(slider)
  control.parentNode.removeChild(control)
})

waterControl.addEventListener('click', event => {
  waterControl.querySelector('.button-icon__direction')
    .classList.toggle('button-icon--reverse')

  toggleWater()
})

popupControls.forEach(popupControl => {
  popupControl.addEventListener('click', event => {
    const popupId = popupControl.id.replace('pop--up--button--', '')
    const popup = document.querySelector(`.pop-up--${popupId}`)

    togglePopup(popupControl, popup)
  })
})

toggleWater(true)
updateScene()


// Faalkans
const pipingButtons = Array.from(document.querySelectorAll('[data-js-select-piping]'))
const pipingImgs = Array.from(document.querySelectorAll('.controls__faalkans-img'))
const pipingText = document.querySelector('.controls__faalkans-desc')
const pipingLayers = [
  '#piping--standaard',
  '#piping--variant-a',
  '#piping--variant-b'
]

const pipingScenarios = {
  'standaard': { stage: { kruin: 7.6 } },
  'variant-a': { stage: { kruin: 8.5 } },
  'variant-b': { stage: { kruin: 8.5 } }
}

pipingButtons.forEach(node => {
  const variant = node.dataset.jsSelectPiping
  let points

  node.addEventListener('click', event => {
    event.preventDefault()
    pipingButtons.forEach(node => node.classList.remove('button--active'))
    node.classList.add('button--active')

    pipingImgs.forEach(node => node.style.display = 'none')
    pipingImgs
      .filter(node => node.classList.contains(`controls__faalkans-img--${variant}`))
      .forEach(node => node.style.display = 'block')

    pipingText.innerHTML = faalkansText[variant]

    pipingLayers.forEach(pipeId =>
      document.querySelector(pipeId).style.opacity = 0)

    document.querySelector(`#piping--${variant}`).style.opacity = 1;

    points = getPipingPolygonPoints(variant)

    Dijk.animate({ points }, 1000, mina.easeinout)
    updateIndicator(pipingScenarios[variant], variant)
  })
})

setTimeout(() => {
  document.querySelector('.loader').style.opacity = 0;
}, 1000)

// Scalerrrrrrg

const sidebars = document.querySelectorAll('.controls')
const fullX = 1920

function scaleSiderbar (event) {
  const scaleFactor = window.innerWidth / fullX
  sidebars.forEach(sidebar => sidebar.style.transform = `scale(${scaleFactor})`)
}

window.addEventListener('resize', scaleSiderbar)
scaleSiderbar()